import type { AdminPanelKey } from '../components/layouts/main-menu/admin-menu-nav'

/**
 * Validates a `?modals=admin:<key>` deep-link value against the set of known
 * panel keys and narrows it to an {@link AdminPanelKey}. Returns `null` for an
 * absent or unknown value so the shell can fall back to the default panel
 * without closing the modal. The shell builds `validKeys` from `ADMIN_TARGETS`;
 * the decider only validates and narrows.
 */
export function toValidAdminKey(
  value: string | null | undefined,
  validKeys: ReadonlySet<string>
): AdminPanelKey | null {
  return value != null && validKeys.has(value) ? (value as AdminPanelKey) : null
}
